type StorageKeysType = {
  auth_token: string;
  promohub_plan_id: string;
  persisted_pathname: string;
};

export const STORAGE_KEY: StorageKeysType = {
  auth_token: 'adc-auth-token',
  promohub_plan_id: 'promohub_plan_id',
  persisted_pathname: 'persisted_pathname',
};
